import { openBlock as c, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ e("path", { d: "M9 8.5h1.5v2H9V12H7v-1.5H5.5v-2H7V7h2v1.5Z" }, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.145.665a.75.75 0 0 0-.041 1.499v1.709l-.12.03c-1.21.37-2.06 1.5-2.06 2.77v6.31c0 .23 0 .49.03.71.03.19.16.83.55 1.16.39.33.64.42.64.42.17.07.34.11.53.14.22.03.48.03.75.03h5.19c0-.002.121-.008.264-.014.188-.01.414-.02.456-.026.18-.02.36-.07.52-.13 0 0 .43-.1.69-.36.26-.26.37-.7.37-.7.06-.16.1-.33.13-.52.03-.22.03-.48.03-.75v-6.27c0-1.29-.83-2.4-2.06-2.77l-.1-.03v-1.71a.75.75 0 0 0-.059-1.498h-5.71Zm-.261 13.268c-.15-.02-.24-.06-.31-.13a.908.908 0 0 1-.11-.32c-.02-.16-.02-.34-.02-.55v-6.27c0-.61.41-1.16.99-1.33l1.17-.358.02-2.802h2.81l-.015 2.811 1.175.359c.59.18.99.71.99 1.33v6.31c0 .18 0 .36-.02.52-.02.14-.06.23-.13.3-.07.07-.16.11-.3.13-.16.02-.35.02-.55.02h-5.19c-.17 0-.36 0-.51-.02Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  l,
  n
];
function v(h, r) {
  return c(), t("svg", o, [...d]);
}
const a = { render: v };
export {
  a as default,
  v as render
};
